export const FEDERAL_SUBTYPE_ID = 640;
export const UTILITY_EV_CHARGING_OFFER_SUBTYPE_ID = 575;
export const THIRD_PARTY_CHARGER_OFFER_SUBTYPE_ID = 672;
